/* Running Premium — theme scripts */
(function () {
  'use strict';

  /* Mobile menu */
  document.addEventListener('click', function (event) {
    var burger = event.target.closest('[data-menu-toggle]');
    if (!burger) return;
    var drawer = document.getElementById('HeaderDrawer');
    if (drawer) drawer.classList.toggle('is-open');
  });

  /* Announcement bar */
  var bar = document.querySelector('[data-announcement]');
  if (bar) {
    var slides = bar.querySelectorAll('[data-announcement-slide]');
    if (slides.length > 1) {
      var index = 0;
      var show = function (next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.hidden = i !== index; });
      };
      show(0);
      bar.querySelectorAll('[data-announcement-prev]').forEach(function (el) {
        el.addEventListener('click', function () { show(index - 1); });
      });
      bar.querySelectorAll('[data-announcement-next]').forEach(function (el) {
        el.addEventListener('click', function () { show(index + 1); });
      });
      if (bar.dataset.autorotate === 'true') {
        setInterval(function () { show(index + 1); }, 5000);
      }
    }
  }

  /* Carousels */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    if (!track) return;
    var barFill = carousel.querySelector('[data-carousel-bar]');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');

    var step = function () {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return first.getBoundingClientRect().width + gap;
    };

    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      if (barFill) {
        var width = Math.max(ratio * 100, 8);
        var left = max > 0 ? (track.scrollLeft / max) * (100 - width) : 0;
        barFill.style.width = width + '%';
        barFill.style.left = left + '%';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* Header solid-on-scroll (On-like) */
  var header = document.querySelector('[data-header-overlay]');
  if (header) {
    var threshold = 80;
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > threshold);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Galerie fiche produit */
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function (event) {
      event.preventDefault();
      var stage = document.querySelector('.pdp__stage img');
      if (stage) stage.src = thumb.dataset.src;
      document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Localization selects */
  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      var input = form.querySelector('input[name="' + select.dataset.field + '"]');
      if (input) input.value = select.value;
      form.submit();
    });
  });

  /* Variant picker */
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.location.href = url.toString();
    });
  });
})();
